module.exports = __webpack_public_path__ + "img/d-wbzx-banner2@2x.c22bf2c7.jpg";